import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import * as Yup from "yup";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import { FormGroup, Label, Button, UncontrolledPopover, PopoverHeader, PopoverBody, Modal, ModalHeader, ModalBody, Spinner } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useMutation, useQuery } from "@tanstack/react-query";
import { loginAxios } from '../../../config/axios.config';
import { toast, ToastContainer } from "react-toastify";
import {
    Icon,
    RSelect,
    Row,
    Col,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
} from "../../../components/Component";

const SizeTable = ({ sizeList, inventoryData, productId, poType, designerId }) => {

    const userLoginDetails = JSON.parse(localStorage.getItem("userInitDetails"));

    const visitFormRef = useRef();

    const dispatch = useDispatch();

    const timeOptions = [
        { value: "day", label: "Day" },
        { value: "week", label: "Week" },
        // { value: "hour", label: "Days" },
    ];



    const formClass = classNames({
        "form-validate": true,
        "is-alter": 'alter',
    });

    const [renderData, setRenderData] = useState({ rangeRates: [{ size_id: '', quantity: 0, drts_quantity: 0, price_or_cost: 0, discount_percent_by_desg: 0, discount_percent_by_desg_drts: 0, designer_date_of_delivery: '', designer_day_hour_week: '', status: null }] });
    const [fromEdit, setFromEdit] = useState(true);

    const [priceModal, setPriceModal] = useState(false);
    const [updatedPrice, setUpdatedPrice] = useState(0);

    useEffect(() => {
        if (inventoryData && inventoryData.length > 0) {
            var tmpData = inventoryData;
            for (var i = 0; i < tmpData.length; i++) {

                delete tmpData[i].fc_id
                delete tmpData[i].productStock
                delete tmpData[i].productCost
                delete tmpData[i].productID
                delete tmpData[i].productSetId

                if (tmpData[i].status == null) {
                    tmpData[i].status = "Not Initiated"
                }

                tmpData[i].old_record = true
            }

            setRenderData({ rangeRates: tmpData });
        }
    }, [inventoryData])

    const toggleFormEdit = () => {
        setFromEdit(!fromEdit);
    }

    const handleCancel = () => {
        toggleFormEdit();

        var tmpData = inventoryData;

        for (var i = 0; i < tmpData.length; i++) {

            delete tmpData[i].fc_id
            delete tmpData[i].productStock
            delete tmpData[i].productCost
            delete tmpData[i].productID
            delete tmpData[i].productSetId

            if (tmpData[i].status == null) {
                tmpData[i].status = "Not Initiated"
            }
        }
        visitFormRef.current.resetForm();
        setRenderData({ rangeRates: tmpData });

    }

    const onFormSubmit = () => {
        if (visitFormRef.current)            
            visitFormRef.current.handleSubmit();            
    }

    const onSubmit = (value) => {
                
        const values = value.rangeRates;
        var collect = [];

        for (var i = 0; i < values.length; i++) {
            collect.push({
                "product_id": parseInt(productId),
                "mto_stock": values[i].quantity,
                "drts_quantity": values[i].drts_quantity,

                // "drts_delivery_days": values[i].drts_quantity > 0 ? 7 : '',
                "drts_delivery_days": 7,
                "price_or_cost": values[i].price_or_cost,
                "designer_discount": values[i].discount_percent_by_desg,
                "designer_discount_drts": values[i].discount_percent_by_desg_drts,
                "designer_id": designerId,

                "designer_delivery_time": values[i].designer_date_of_delivery,
                "designer_delivery_time_unit": values[i].designer_day_hour_week,
                "size_id": parseInt(values[i].size_id),
                // "size": "XXL",
                "merchandiser_name": "aza"
            })
        }


        const uniqueValues = new Set(collect.map(v => v.size_id));

        if (uniqueValues.size < collect.length) {
            toast.error('Duplicate sizes found', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                progress: false,
            });
        } else {
            updateDetailsCall.mutate(collect)
            setFromEdit(!fromEdit);
        }
    }


    const updateDetails = async (params) => {
        try {
            const { data } = await loginAxios.post(`designers/product-details`, params, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;

        } catch (error) {
            return Promise.reject(error);
        }
    };

    const updateDetailsCall = useMutation(updateDetails, {
        onSettled(data, error) {
            if (data) {
                toast.success(data.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    progress: false,
                });

            } else if (error) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    progress: false,
                });
            }

            dispatch({ type: "INVENTORY_DETAILS_UPDATED", payload: data })

        }
    })



    const [dispatchModal, setdispatchModal] = useState(false);

    const toggleDispatchModal = () => {
        setdispatchModal(!dispatchModal);
    };

    const handleChangeAll = () => {

        togglePriceModal();
        

        // let tempObj = JSON.parse(JSON.stringify(renderData));

        //  let tempArr = tempObj?.rangeRates?.map((item, index) => {
            
            
        // visitFormRef.current.setFieldValue(`rangeRates.${index}.price_or_cost`, 200, false);

        //     item.price_or_cost = 200

        //     return item;

        //     });

        //  tempObj.rangeRates = tempArr;
         
        //  console.log(tempObj);
        //  setRenderData(tempObj);
         

    }
    

    const togglePriceModal = () => {
        setPriceModal(!priceModal);
    };

    const handleUpdatedPrice = (val) => {
        setUpdatedPrice(val)
    }

    const submitUpdatedPrice = () => {
        for(let i = 0; i < renderData?.rangeRates?.length; i++) {
            visitFormRef.current.setFieldValue(`rangeRates.${i}.price_or_cost`, updatedPrice, false);
        }

        togglePriceModal();
        setUpdatedPrice(0);
    }

    return (<>

        <BlockHead size="sm">
            <BlockBetween>
                <BlockHeadContent>
                    <h6 className="title" style={{marginBottom: '10px'}}>Product Inventory <Icon name="help" onClick={toggleDispatchModal}></Icon></h6>

                </BlockHeadContent>
                <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">

                        {userLoginDetails.profile_approval_status != "PENDING" ? <>

                            {fromEdit ?
                                <Button color="primary" onClick={toggleFormEdit} disabled={updateDetailsCall.isLoading}>
                                    {updateDetailsCall.isLoading ? <Spinner color="light" size='sm' />: <Icon name="edit" />}
                                    <span>Edit</span>
                                </Button> : <>

                                    <Button
                                        color="light" outline
                                        className="bg-white d-none d-sm-inline-flex"
                                        onClick={handleChangeAll}
                                    >
                                        {/* <Icon name="cross" /> */}
                                        <span>Apply to all</span>
                                    </Button>

                                    <Button
                                        color="light" outline
                                        className="bg-white d-none d-sm-inline-flex ml-2"
                                        onClick={handleCancel}
                                    >
                                        <Icon name="cross" />
                                        <span>Cancel</span>
                                    </Button>

                                    <Button color="primary" type="submit" className="ml-2" onClick={onFormSubmit}>
                                        <Icon name="save" />
                                        <span>Save</span>
                                    </Button>
                                </>}

                        </> : null}

                    </div>
                </BlockHeadContent>
            </BlockBetween>
        </BlockHead>

        <div className="form-block">
            <div>
                <Formik
                    enableReinitialize={true}
                    initialValues={renderData}
                    validationSchema={Yup.object({
                        rangeRates: Yup.array().of(
                            Yup.object().shape({
                                // year: Yup.string().required("Select Size"),
                                size_id: Yup.number()
                                    .required('Select Size'),
                                
                                drts_quantity: Yup.string().trim().required()
                                .matches(/^(0|([1-9]\d*))$/, 'Numbers only'),
                                
                                price_or_cost: Yup.string()
                                    .required('This field is required')
                                    .matches(/^[1-9][0-9]*/, 'Value greater than 0 is required'),

                                designer_date_of_delivery: Yup.string()
                                    .required('Delivery time required')
                                    // .matches(/^[0-9]*$/, 'Numbers Only'),
                                    .matches(/^[1-9][0-9]*/, 'Value greater than 0 is required'),
                                designer_day_hour_week: Yup.string()
                                    .required('Select Time Type'),

                                discount_percent_by_desg: Yup.string()
                                    // .required('rate value required')
                                    .matches(/^(100(\.00?)?|[1-9]?\d(\.\d\d?)?)$/, 'Numbers between 0-100 only'),

                                    discount_percent_by_desg_drts: Yup.string()
                                        // .required('rate value required')
                                        .matches(/^(100(\.00?)?|[1-9]?\d(\.\d\d?)?)$/, 'Numbers between 0-100 only'),
                                    
                            })
                        )
                    })}
                    innerRef={visitFormRef}
                    onSubmit={(value) => { onSubmit(value) }}

                >
                    {props => {
                        const { handleChange, values, errors, touched, handleSubmit, resetForm } = props;
                        return (
                            <>
                                <Form className={formClass}>
                                    <fieldset disabled={fromEdit}>
                                        <FieldArray
                                            name="rangeRates"
                                            render={arrayHelpers => {
                                                var rangeRates = values.rangeRates;
                                                return (
                                                    <Row className="g-gs">
                                                        <Col md="12">
                                                            <table className="catalogue-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className="inventory-size-dropdown">Size*</th>

                                                                        <th scope="col" className="inventory-price-col">{poType == 'MRP Based' ? 'Price' : 'Cost'}*</th>

                                                                        <th scope="col">MTO Stock <Icon name="help" id="mtoStockPop"></Icon></th>

                                                                        <th scope="col">Discount % <Icon name="help" id="discountPop"></Icon></th>
                                                                        <th scope="col">MTO Delivery Time*</th>

                                                                        <th scope="col" className="inventory-mtotime-col">MTO Time Type*</th>
                                                                        <th scope="col">RTS Stock <Icon name="help" id="rtsStockPop"></Icon></th>
                                                                        <th scope="col">RTS Discount % <Icon name="help" id="discountPop"></Icon></th>
                                                                        
                                                                        <th scope="col">Approval Status</th>

                                                                        {!fromEdit &&
                                                                            <th>
                                                                                <span className="btn btn-outline-success"
                                                                                    onClick={() =>
                                                                                        arrayHelpers.push({
                                                                                            size_id: "",
                                                                                            quantity: 0,
                                                                                            drts_quantity: 0,
                                                                                            price_or_cost: 0,
                                                                                            discount_percent_by_desg: 0,
                                                                                            discount_percent_by_desg_drts: 0,
                                                                                            designer_date_of_delivery: '',
                                                                                            designer_day_hour_week: '',
                                                                                            status: null
                                                                                        })
                                                                                    }
                                                                                >
                                                                                    +
                                                                                </span>
                                                                            </th>
                                                                        }

                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                    {rangeRates && rangeRates.length > 0
                                                                        ? rangeRates.map((record, index) => (
                                                                            <tr key={index}>

                                                                                <td>

                                                                                    <Field as="select" name={`rangeRates.${index}.size_id`} className="form-control" 
                                                                                        disabled={record?.old_record == true ? true : false}
                                                                                    >
                                                                                        <option value="" label="">
                                                                                            Select size{" "}
                                                                                        </option>
                                                                                        {sizeList.map(item =>
                                                                                            <option
                                                                                                // disabled={rangeRates[index].size_id == item.size_id ? true : false}
                                                                                                value={item.sizeID} label={item.sizeTitle} />
                                                                                        )}
                                                                                    </Field>
                                                                                    <ErrorMessage name={`rangeRates.${index}.size_id`} render={msg => <span className="invalid">{msg}</span>} />

                                                                                </td>


                                                                                <td>
                                                                                    <Field
                                                                                        placeholder="product Price"
                                                                                        name={`rangeRates.${index}.price_or_cost`}
                                                                                        className="form-control"
                                                                                        type="number"
                                                                                    />

                                                                                    <ErrorMessage name={`rangeRates.${index}.price_or_cost`} render={msg => <span className="invalid">{msg}</span>} />

                                                                                </td>

                                                                                <td>
                                                                                    <Field
                                                                                        placeholder="quantity"
                                                                                        name={`rangeRates.${index}.quantity`}
                                                                                        className="form-control"
                                                                                        type="number"
                                                                                    />
                                                                                </td>



                                                                                <td>
                                                                                    <Field
                                                                                        placeholder="Discount"
                                                                                        name={`rangeRates.${index}.discount_percent_by_desg`}
                                                                                        className="form-control"
                                                                                        type="number"
                                                                                    />

                                                                                    <ErrorMessage name={`rangeRates.${index}.discount_percent_by_desg`} render={msg => <span className="invalid">{msg}</span>} />

                                                                                </td>

                                                                                <td>
                                                                                    <Field
                                                                                        placeholder="Delivery Time"
                                                                                        name={`rangeRates.${index}.designer_date_of_delivery`}
                                                                                        className="form-control"
                                                                                        type="number"
                                                                                    />
                                                                                    <ErrorMessage name={`rangeRates.${index}.designer_date_of_delivery`} render={msg => <span className="invalid">{msg}</span>} />

                                                                                </td>
                                                                                <td>
                                                                                    <Field as="select" name={`rangeRates.${index}.designer_day_hour_week`} className="form-control">
                                                                                        <option value="" label="">
                                                                                            Select Time{" "}
                                                                                        </option>
                                                                                        {timeOptions.map(item =>
                                                                                            <option value={item.value} label={item.label}>{item.value}</option>
                                                                                        )}
                                                                                    </Field>
                                                                                    <ErrorMessage name={`rangeRates.${index}.designer_day_hour_week`} render={msg => <span className="invalid">{msg}</span>} />
                                                                                </td>

                                                                                <td>
                                                                                    <Field
                                                                                        placeholder="drts_quantity"
                                                                                        name={`rangeRates.${index}.drts_quantity`}
                                                                                        className="form-control"
                                                                                        type="number"
                                                                                    />
                                                                                    <ErrorMessage name={`rangeRates.${index}.drts_quantity`} render={msg => <span className="invalid">{msg}</span>} />
                                                                                </td>
                                





                                                                                <td>
                                                                                    <Field
                                                                                        placeholder="DRTS Discount"
                                                                                        name={`rangeRates.${index}.discount_percent_by_desg_drts`}
                                                                                        className="form-control"
                                                                                        type="number"
                                                                                    />

                                                                                    <ErrorMessage name={`rangeRates.${index}.discount_percent_by_desg_drts`} render={msg => <span className="invalid">{msg}</span>} />

                                                                                </td>


                                                                       


                                                                                <td style={{ textTransform: 'capitalize' }}>
                                                                                    <Field
                                                                                        placeholder="Status"
                                                                                        name={`rangeRates.${index}.status`}
                                                                                        className="form-control status-capitalize"
                                                                                        type="text"
                                                                                        disabled
                                                                                    />
                                                                                </td>
                                                                                <td className="td-bottom">
                                                                                    {!record?.old_record &&
                                                                                        <>
                                                                                            {false ? <button>ANY</button> : <>

                                                                                                {rangeRates.length > 1 && <span className="btn btn-outline-danger"
                                                                                                    onClick={() => arrayHelpers.remove(index)}> x </span>}
                                                                                            </>}
                                                                                            </>
                                                                                    }
                                                                                </td>

                                                                                {/* {!fromEdit &&
                                                                                    <td className="td-bottom">
                                                                                        {false ? <button>ANY</button> : <>

                                                                                            {rangeRates.length > 1 && <span className="btn btn-outline-danger"
                                                                                                onClick={() => arrayHelpers.remove(index)}> x </span>}
                                                                                        </>}
                                                                                    </td>
                                                                                } */}
                                                                            </tr>
                                                                        ))
                                                                        : null}
                                                                </tbody>
                                                            </table>
                                                        </Col>
                                                    </Row>
                                                );
                                            }}
                                        />
                                    </fieldset>
                                </Form>
                            </>
                        );
                    }}
                </Formik>
            </div>
        </div>


        <Modal size="md" isOpen={dispatchModal} toggle={toggleDispatchModal}>
            <ModalHeader
                toggle={toggleDispatchModal}
                close={
                    <button className="close" onClick={toggleDispatchModal}>
                        <Icon name="cross" />
                    </button>
                }
            >
                User guide for updating stock:
            </ModalHeader>
            <ModalBody>

                <div className="nk-tnx-details mt-sm-3">
                    {/* <ul> */}


                    <li>From “Product Catalog”, click on a product to open “Product Details” page.</li>

                    <li>In “Product Inventory” section, click on “Edit” button to update inventory details.</li>

                    <li>Designers can add/remove MTO and RTS stock by entering updated quantities. Approval from Aza is not required when stock is updated.</li>

                    <li>Designers can update MRP/Cost and Discount which will go for approval to Aza. Once reviewed and approved by Aza, changes made by designers will be reflected in designer panel. Approval status can be viewed in “Approval Status” column.</li>

                    <li>Designers can change Delivery timeline by entering appropriate values in “Delivery time” and “Time type” columns. Approval from Aza is not required while changing delivery time.</li>

                    <li>Delivery timelines shown are applicable to MTO inventory only. Delivery time of RTS inventory is set to 5 days by default which cannot be changed by designer.</li>
                

                    {/* </ul> */}

                </div>

            </ModalBody>
        </Modal>


        <ToastContainer />

        <UncontrolledPopover trigger="legacy" placement="bottom" target="mtoStockPop">
            <PopoverHeader>MTO Stock</PopoverHeader>
            <PopoverBody>
                <p className="popover-text">MTO is “Made to Order” stock. This is virtual stock as the product is made only after designers receive a Purchase Order from Aza.</p>
            </PopoverBody>
        </UncontrolledPopover>

        <UncontrolledPopover trigger="legacy" placement="bottom" target="rtsStockPop">
            <PopoverHeader>RTS Stock</PopoverHeader>
            <PopoverBody>
                <p className="popover-text">RTS is “Ready to Ship” inventory. Default delivery time for RTS inventory is equal to 5 days. Any readily available stock which can be delivered to Aza in less than or equal to 5 days can be added as RTS stock. Designer won’t be able to change the delivery time of RTS stock even if it is less than 5 days.</p>
            </PopoverBody>
        </UncontrolledPopover>


        <UncontrolledPopover trigger="legacy" placement="bottom" target="discountPop">
            <PopoverHeader>Discount</PopoverHeader>
            <PopoverBody>
                <p className="popover-text">Discount given by designer on Price/Cost </p>
            </PopoverBody>
        </UncontrolledPopover>


        <Modal size="sm" isOpen={priceModal} toggle={togglePriceModal}>
            <ModalHeader
                toggle={togglePriceModal}
                close={
                    <button className="close" onClick={togglePriceModal}>
                        <Icon name="cross" />
                    </button>
                }
            >
                Change price
            </ModalHeader>
            <ModalBody>

                <Row>
                    <Col lg="12">
                        <FormGroup className="form-group">
                            <label className="form-label" htmlFor="updated_price">
                                Update Price
                            </label>
                            <div className="form-control-wrap">
                                <input
                                    type="text"
                                    id="updated_price"
                                    className="form-control"
                                    value={updatedPrice}
                                    onChange={(e) => {
                                        handleUpdatedPrice(e.target.value);
                                    }}
                                />
                            </div>
                        </FormGroup>
                    </Col>

                    <Col lg="6">
                        <button className="btn btn-sm btn-primary mt-2" onClick={submitUpdatedPrice}>Submit</button>
                    </Col>
                </Row>

            </ModalBody>
        </Modal>

    </>)
};

export default SizeTable;